import dashboard from '@/assets/images/dashboard.svg';
import user from '@/assets/images/user.svg';
import logout from '@/assets/images/logout.svg';

export const DASHBOARD_SVG = dashboard;
export const USER_SVG = user;
export const LOGOUT_SVG = logout;









